<template>
  <v-dialog width="800px" persistent v-model="editDialog">
    <template v-slot:activator="{ on }">
      <v-btn icon v-on="on">
      <v-icon>mdi-pencil</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title>Edit Member</v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-text-field
          label="Member ID"
          name="memberid"
          id="memberid"
          v-model="editedmemberid"
          :rules="rule1"
        >
        </v-text-field>
        <v-text-field
          label="Full Name"
          name="name"
          id="name"
          v-model="editedname"
          :rules="rule1"
        >
        </v-text-field>
        <v-select
          :items="items"
          label="Gender"
          name="gender"
          id="gender"
          v-model="editedgender"
          :rules="rule1"
        >
        </v-select>
        <v-text-field
          label="Role"
          name="role"
          id="role"
          v-model="editedrole"
          :rules="rule1"
        >
        </v-text-field>
        <v-text-field
          label="Work Location"
          name="location"
          id="location"
          v-model="editedlocation"
          :rules="rule2"
        >
        </v-text-field>
        <v-text-field
          label="Email Address"
          name="email"
          id="email"
          v-model="editedemail"
          :rules="rule2"
        >
        </v-text-field>
        <v-text-field
          label="Contact Number"
          name="contact"
          id="contact"
          v-model="editedcontact"
          :rules="rule1"
        >
        </v-text-field>
        <v-divider></v-divider>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          :disabled="formIsNotValid"
          class="ma-2"
          color="green"
          @click="onSaveChanges"
        >
          <v-icon left>mdi-content-save</v-icon>
          Save Changes
        </v-btn>
        <v-btn
          class="ma-2"
          color="grey"
          @click="editDialog=false"
        >
          <v-icon left>mdi-close</v-icon>
          Cancel
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ['member'],
  data () {
    return {
      editDialog: false,
      editedmemberid: this.member.memberid,
      editedname: this.member.name,
      editedgender: this.member.gender,
      editedrole: this.member.role,
      editedlocation: this.member.location,
      editedemail: this.member.email,
      editedcontact: this.member.contact,
      items: ['M', 'F'],
      rule1: [
        value => !!value || 'Required',
        value => (value || '').length <= 40 || 'Max 40 characters'
      ],
      rule2: [
        value => !!value || 'Required',
        value => (value || '').length <= 100 || 'Max 100 characters'
      ]
    }
  },
  methods: {
    onSaveChanges () {
      if (this.editedmemberid.trim() === '' || this.editedname.trim() === '' || this.editedgender.trim() === '' || this.editedrole.trim() === '' || this.editedlocation.trim() === '' || this.editedemail.trim() === '' || this.editedcontact.trim() === '') {
        return
      }
      this.editDialog = false
      this.$store.dispatch('updateMember', {
        id: this.member.id,
        memberid: this.editedmemberid,
        name: this.editedname,
        gender: this.editedgender,
        role: this.editedrole,
        location: this.editedlocation,
        email: this.editedemail,
        contact: this.editedcontact
      })
    }
  },
  computed: {
    formIsNotValid () {
      return this.editedmemberid === '' ||
      this.editedname === '' ||
      this.editedgender === '' ||
      this.editedrole === '' ||
      this.editedlocation === '' ||
      this.editedemail === '' ||
      this.editedcontact === ''
    }
  }
}
</script>

<style>

</style>
